import React, { Component } from 'react'
import { connect } from 'react-redux'
import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import { Tabs, Tab, Typography } from '@material-ui/core'

import { getShopList } from '../../../actions/shop'
import WmDispatchShopTab from '../../../components/WmDispatch/WmDispatchShopTab'
import WmDispatchErrorLogsTab from '../../../components/WmDispatch/WmDispatchErrorLogsTab'
import WmDispatchDefaultSettingsTab from '../../../components/WmDispatch/WmDispatchDefaultSettingsTab'
import { openErrorMessage } from '../../../actions/message'
import { getDCHSettingsByCompanyId } from '../../../actions/dispatch'

const wmDispatchTabs = [
  'Shops',
  //"Default Settings",
  //"Error Logs"
]

class WmDispatch extends Component {
  state = {
    activeTab: 'Shops',
  }

  componentDidMount() {
    let companyId = JSON.parse(localStorage.getItem('session')).company.id
    this.props.dispatch(getShopList())
    this.props.dispatch(getDCHSettingsByCompanyId(companyId))
  }

  wmDispatchTabs = wmDispatchTabs.map((tab) => <Tab label={tab} value={tab} />)

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  onError = (message) => this.props.dispatch(openErrorMessage(message))

  renderTab = (activeTab) => {
    const { shopsList = {} } = this.props.shopReducer
    const { msDispatchSettingsList = [] } = this.props.dispatchReducer
    const shopListValues = shopsList.values || []
    const shopListValuesFiltered = shopListValues.filter((s) =>
      msDispatchSettingsList.map((m) => m.shopId).includes(s.id),
    )
    switch (activeTab) {
      case 'Shops':
        return (
          <WmDispatchShopTab
            shopsList={shopListValuesFiltered}
            shopDispatchList={msDispatchSettingsList}
            onError={this.onError}
          />
        )
      case 'Default Settings':
        return <WmDispatchDefaultSettingsTab />
      case 'Error Logs':
        return <WmDispatchErrorLogsTab />
      default:
        return null
    }
  }

  render() {
    const { activeTab } = this.state
    return (
      <div>
        <div>
          <ul class="breadcrumb">
            <li>Integrations</li>
            <li>WM Dispatch</li>
          </ul>
        </div>
        <div style={{ marginTop: '2rem' }}>
          <Tabs
            value={activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {this.wmDispatchTabs}
          </Tabs>
          {this.renderTab(activeTab)}
        </div>
      </div>
    )
  }
}

const WmDispatchTitle = ContainerWithTitleWrapper(WmDispatch, 'WM Dispatch')
const WmDispatchConnected = connect(({ shopReducer, dispatchReducer, dispatch }) => ({
  shopReducer,
  dispatchReducer,
  dispatch,
}))(WmDispatchTitle)

export default WmDispatchConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/WmDispatch.js